export default {
  cancel: 'Cancel',
  close: 'Close',
  save: 'Save',
  saveChanges: 'Save Changes',
  delete: 'Delete',
  deleteNotice: 'Delete notice',
  editNotice: 'Edit notice',
  newTitle: 'New Message',
  newTitleMobile: 'New Notice',
  editTitle: 'Edit Notice',
  newBadge: 'New Notice!',
  titleLabel: 'Title:',
  titleMobile: 'Title',
  descriptionLabel: 'Description:',
  descriptionMobile: 'Description',
  attachPreview: 'Attach a preview image:',
  attachArticle: 'Attach an image to the article:',
  attachPhoto: 'Attach photo',
  attachPhotoMobile: 'Attach Photo',
  removeFile: 'Remove file',
  scheduleDuration: 'Set how long the notice lasts:',
  contentPlaceholder: 'Start writing here...',
  publishTo: 'Publish notice to:',
  publishAll: 'Publish to everyone',
  publishCustom: 'Publish by Role/Location',
  chooseRoles: 'Choose roles',
  chooseLocations: 'Choose locations',
  roles: 'Roles',
  locations: 'Location',
  allRoles: 'All roles',
  allLocations: 'All locations',
  searchLocations: 'Search location',
  noResults: 'No results',
  loadMore: 'Load more',
  removeChip: 'Remove {name}',
  publish: 'Publish Notice',
  schedule: 'Schedule Notice',
  confirmDeleteTitle: 'Do you want to delete this notice?',
  confirmDeleteBody: 'Once deleted, this notice cannot be recovered.',
  confirmSaveTitle: 'Do you want to save changes to this notice?',
  confirmSaveBody: 'Once saved, the changes cannot be undone.',
  publishedBy: 'Published by {name}',
  fieldsRequired: 'Please fill in all required fields',
  audienceRequired: 'Choose at least one role or location, or publish to everyone.',
  created: 'Notice created',
  scheduled: 'Notice scheduled',
  updated: 'Notice updated',
  deleted: 'Notice deleted',
  createError: 'Error creating the notice',
  scheduleError: 'Error scheduling the notice',
  updateError: 'Error saving the changes',
  deleteError: 'Error deleting the notice',
  loadError: 'Could not load the notice',
  editor: {
    toolbar: 'Formatting tools',
    style: 'Text style',
    font: 'Typography',
    color: 'Color',
    bold: 'Bold',
    italic: 'Italic',
    underline: 'Underline',
    strike: 'Strikethrough',
    alignLeft: 'Align left',
    alignCenter: 'Center',
    alignRight: 'Align right',
    orderedList: 'Numbered list',
    bulletList: 'Bulleted list',
    link: 'Insert link',
    linkHint: 'Type the site address (https://...).',
    insert: 'Insert',
    image: 'Insert image',
    imageTooBig: 'The image must not exceed 5 MB.',
    imageError: 'Could not upload the image.'
  }
}
